import * as OrderSummary from './CheckoutOrderSummary.css';
import * as OrderSegments from './OrderSegments/OrderSegments.css';
import { createTheme } from '../utils';
const defaultTheme = {
    OrderSummary,
    OrderSegments
};
export default defaultTheme;
export const { useTheme } = createTheme(defaultTheme);
